<template>
  <div
    :data-size="size"
    v-html="text"
    class="p"
  />
</template>

<script>
export default {
  name: 'Paragraph',

  props: {
    size: {
      type: String,
      required: false,
      default: 'normal'
    },

    text: {
      type: String,
      required: true,
    },
  },
}
</script>

<style lang="scss">
.p {
  margin: 0;

  &[data-size="small"] {
    @include fluid-type(375px, 1920px, 16px, 16px, 24px, 35px);
    p {
      @include fluid-type(375px, 1920px, 16px, 16px, 24px, 35px);
    }
  }

  &[data-size="normal"] {
    @include fluid-type(375px, 1920px, 26px, 65px, 35px, 82px);
    p {
      @include fluid-type(375px, 1920px, 26px, 65px, 35px, 82px);
    }
  }

  &[data-size="big"] {
    @include fluid-type(375px, 1920px, 26px, 80px, 35px, 95px);
    p {
      @include fluid-type(375px, 1920px, 26px, 80px, 35px, 95px);
    }
  }
}
</style>

<style lang="scss">
p em, p i {
  display: inline;
  font-family: $font-family-alt;
  font-weight: 400;
  font-style: normal;

  // text-shadow:
  // -2px -2px $color-bg,
  // -2px 2px $color-bg,
  // 2px -2px $color-bg,
  // 2px 2px $color-bg;

  // background-image: linear-gradient(to right, $color-text 100%, $color-bg 0%);
  background-position: 0 95%;
  background-size: 100% 1px;
  background-repeat: repeat-x;
}

[data-size="big"] p strong, [data-size="normal"] p strong, [data-size="big"] p b, [data-size="normal"] p b {
  font-family: $font-family-alt;
  font-weight: 400;
  font-style: normal;
}
</style>

